"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryPartsCount = exports.arbitraryDocumentCount = exports.arbitraryFollowingCount = exports.arbitraryFollowerCount = exports.arbitraryStarCount = void 0;
const fast_check_1 = require("fast-check");
/**
 * Social counts are arbitrarily positive semidefinite numbers.
 */
exports.arbitraryStarCount = fast_check_1.nat;
exports.arbitraryFollowerCount = fast_check_1.nat;
exports.arbitraryFollowingCount = fast_check_1.nat;
exports.arbitraryDocumentCount = fast_check_1.nat;
exports.arbitraryPartsCount = fast_check_1.nat;
//# sourceMappingURL=social.js.map